import _ from 'lodash/fp'

export * from './conversion'
export * from './collection'
export * from './function'
export * from './string'
export * from './object'
export * from './aspect'
export * from './array'
export * from './logic'
export * from './regex'
export * from './lang'
export * from './lens'
export * from './tree'
export * from './iterators'

import * as conversion from './conversion'
import * as collection from './collection'
import * as fn from './function'
import * as string from './string'
import * as object from './object'
import * as aspect from './aspect'
import * as array from './array'
import * as logic from './logic'
import * as regex from './regex'
import * as lang from './lang'
import * as lens from './lens'
import * as tree from './tree'
import * as iterators from './iterators'

// Math
// ----
export const greaterThanOne = _.lt(1)

// Version
// ----
export const VERSION = global.__VERSION__

// Allows `import F from 'futil-js'`
export default {
  ...conversion,
  ...collection,
  ...fn,
  ...string,
  ...object,
  ...aspect,
  ...array,
  ...logic,
  ...regex,
  ...lang,
  ...lens,
  ...tree,
  ...iterators,
  greaterThanOne,
  VERSION,
}
